import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!

  return (_openBlock(), _createBlock(_component_ion_select, {
    "model-value": _ctx.modelValue,
    onIonChange: _ctx.handleChange,
    disabled: _ctx.disabled,
    label: "Unité :",
    placeholder: "Select"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.unities, (unity) => {
        return (_openBlock(), _createBlock(_component_ion_select_option, {
          key: unity.short_name,
          value: unity.short_name
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(unity.label) + " " + _toDisplayString(unity.short_name ? '(' + unity.short_name + ')' : ''), 1)
          ]),
          _: 2
        }, 1032, ["value"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["model-value", "onIonChange", "disabled"]))
}